import { tx } from '@transifex/native';
import config from 'config';

export const setupTransifex = () =>
  tx.init({
    token: config.transifexToken,
  });
